<template>

    <b-row>
      <b-col cols="12">
        <!-- PERMISSION TABLE -->
        <b-card no-body class="border">
          <b-card-header class="p-1">
            <b-card-title class="font-medium-2">
              <feather-icon icon="LockIcon" size="18"/>
              <span class="align-middle ml-50">{{ $t('Menus Permission')}}</span>
            </b-card-title>
          </b-card-header>
          <b-table striped responsive class="mb-0"
                   :items="authMenus" :fields="fields">
            <template #cell(name)="data">
              {{ JSON.parse(data.value)[$i18n.locale] }}
            </template>
            <template #cell()="data">
              <b-form-checkbox :disabled="disabled(data)"  @change="change(data, $event)" :checked="checked(data)" />
            </template>
            <template #cell(action)="data">
              <b-badge :variant="variant(data)"> {{btnStatus(data)}}</b-badge>
            </template>
          </b-table>
        </b-card>
      </b-col>


      <b-col cols="12">
        <!-- Action Buttons -->
        <b-button
            type="submit"
            variant="primary"
            class="mb-1 mb-sm-0 mr-0 mr-sm-1"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            @click="submit"
        >
         {{ $t('Save Changes')}}
        </b-button>
      </b-col>


    </b-row>
</template>

<script>
import {
  BFormFile,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BAlert,
  BCard,
  BCardText,
  BMedia,
  BMediaAside,
  BMediaBody,
  BLink,BBadge,
  BImg,
  BTable, BFormCheckbox, BCardTitle, BCardHeader,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref, computed } from '@vue/composition-api'
import store from '@/store'

export default {
  components: {
    BButton, BForm, BImg, BFormFile,
    BFormGroup, BFormInput, BRow,
    BCol, BAlert, BCard, BCardText,BBadge,
    BMedia, BMediaAside, BMediaBody,
    BLink,BTable,BFormCheckbox,  BCardTitle, BCardHeader
  },
  directives: {
    Ripple,
  },
  props: {
    authMenus: {
      type: Array,
      default: () => []
    },
    userMenus: {
      type: Array,
      default: () => []
    },
    user: {
      type: Number,
      required: true
    }
  },

  setup(props, { root }) {

    const  fields = ['name','list' ,'create', 'update', 'delete', 'action']

    const checked = (data) => {
      const userPermissions = props.userMenus.find(v => v.id === data.item.id)
      if (userPermissions) {
        if (data.field.key === 'list') return true
        return userPermissions[data.field.key]
      }
      return false
    }

    const changedData = ref({ list: true, create: false, update: false, delete: false })
    const newUserMenus = ref([])


    const disabled = (data) => {

      // console.log(data)
      if (data.field.key === 'list') return false

      // user change this row and added to new menus
      const i = newUserMenus.value.findIndex(v => v.id === data.item.id)
      if (i > -1) return false

      // check he is already has it
      const x = props.userMenus.findIndex(v => v.id === data.item.id)
      if (x > -1) return false

      return true
    }

    const change = (data, value) => {

      // check if he is already has it
      const indexInRealData = props.userMenus.findIndex(v => v.id === data.item.id)
      if (indexInRealData > -1) {
        if (!value) {
          props.userMenus.splice(indexInRealData, 1)
        }
      }

      const index = newUserMenus.value.findIndex(v => v.id === data.item.id)
      if (index > -1){
        if (data.field.key === 'list') {
          if (!value) newUserMenus.value.splice(index, 1)
        }else{
          newUserMenus.value[index][data.field.key] = value
        }
      }
      else {
        if (value){
          changedData.value[data.field.key] = value
          newUserMenus.value.push({...changedData.value, id: data.item.id })
        }
      }
    }


    const submit = id => {

      store.dispatch('app-permission/attachMenusToUser', {
        data: [...props.userMenus,...newUserMenus.value],
        id: props.user
      }).then(res => {
        props.userMenus.push(...newUserMenus.value)
        newUserMenus.value = []
        toaster('Permissions Updated successfully','success','success')
      }).catch(res => {})
    }

    const variant = (data) => {
      const index = newUserMenus.value.findIndex(v => v.id === data.item.id)
      return index > -1 ? 'success' : 'secondary'
    }

    const btnStatus = (data) => {
      const index = newUserMenus.value.findIndex(v => v.id === data.item.id)
      return index > -1 ? 'changed' : 'not changed'
    }

    const toaster = (msg, variant, title) => {
      root.$root.$bvToast.toast(msg, {
        title,
        variant,
        solid: true,
      })
    }

    return {
      checked,
      change,
      fields,
      disabled,
      variant,
      submit,
      btnStatus
    }
  },
}
</script>
